const NUMERIC_IDENTIFIER_PATTERN = /^\d[\d/-]*$/;

export function prepareSentenceSearchQuery(value) {
  const query = String(value || "").trim();
  if (!query) return { query, valid: false };
  if (NUMERIC_IDENTIFIER_PATTERN.test(query)) {
    return { query, valid: true };
  }
  return { query, valid: query.length >= 3 };
}

export function sentenceSearchQueryFromUrl(search = "") {
  return new URLSearchParams(search).get("q") || "";
}

export function sentenceSearchPageFromUrl(search = "") {
  const page = Number(new URLSearchParams(search).get("page"));
  return Number.isInteger(page) && page > 0 ? page : 1;
}

export function buildSentenceSearchUrl(query, { page = 1 } = {}) {
  const parameters = new URLSearchParams({ q: String(query).trim() });
  if (page > 1) parameters.set("page", String(page));
  return `/buscador-sentencias?${parameters.toString()}`;
}

export function sentencePaginationItems(page, totalPages) {
  const total = Math.max(1, Number(totalPages) || 1);
  const current = Math.min(total, Math.max(1, Number(page) || 1));
  if (total <= 7) {
    return Array.from({ length: total }, (_value, index) => index + 1);
  }

  const items = [1];
  if (current > 3) items.push("start-ellipsis");
  for (
    let value = Math.max(2, current - 1);
    value <= Math.min(total - 1, current + 1);
    value += 1
  ) {
    items.push(value);
  }
  if (current < total - 2) items.push("end-ellipsis");
  items.push(total);
  return items;
}
